// src/services/config-service.ts

export interface AppConfig {
    backendUrl: string
    apiBaseUrl: string
    adminToken?: string
}

export class ConfigService {
    private static instance: ConfigService
    private config: AppConfig

    public static getInstance(): ConfigService {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService()
        }
        return ConfigService.instance
    }

    private constructor() {
        // @ts-ignore
        const envBackendUrl = import.meta.env.VITE_BACKEND_URL as string | undefined
        // @ts-ignore
        const envApiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined
        // @ts-ignore
        const envAdminToken = import.meta.env.VITE_ADMIN_TOKEN as string | undefined

        this.config = {
            backendUrl: envBackendUrl || '',
            apiBaseUrl: envApiBaseUrl || envBackendUrl || '',
            adminToken: envAdminToken || '',
        }
    }

    public getBackendUrl(): string {
        return this.config.backendUrl
    }

    public getApiBaseUrl(): string {
        return this.config.apiBaseUrl
    }

    public getAdminToken(): string | undefined {
        return this.config.adminToken
    }
}

export const configService = ConfigService.getInstance()
